import { get } from "@/apis";
import router from "@/router";
import { parseErrorMessage } from "@/utils/util";
import message from "ant-design-vue/lib/message";

export default {
  namespaced: true,
  state: {
    isValid: false, // 链接是否合法
  },
  mutations: {
    SET_VALID(state, payload) {
      state.isValid = payload;
    },
  },
  getters: {
    getValid: (state) => {
      return state.isValid;
    },
  },
  actions: {
    async validateUrlValidity(context, data) {
      message.open({
        content: "正在校验链接...",
        type: "loading",
        duration: 1,
      });
      const res = await get(`/api/Quick/ValidateUrlValidity?alias=${data}`);
      if (res.code === 200 && res.success) {
        context.commit("SET_VALID", res.data);
      } else {
        var pem = parseErrorMessage(res.message);
        if (!!pem) {
          router.push(`/error?title=[${pem.code}]&msg=${pem.message}`);
        }
      }
    },
  },
};
